import { Component, Inject } from "@angular/core";
import { VIEWER_SERVICE } from "../../viewer-components/services/internal-services/viewer-services/inject-base-viewer.service";
import { HttpClient } from "@angular/common/http";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { GeoJSONDatabaseService } from "../../viewer-components/services/internal-services/geojson-database.service";
import { ArcGISLayerResultsDialogComponent } from "./arcgis-layer-results-dialog.component";
import { Viewerlayer } from "../../viewer-components/model/viewerlayer";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";
import {
  GoogleAnalyticsConstantsCategory,
  GoogleAnalyticsConstantsEvents,
} from "../../shared/model/google-analytics-constants";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { GoogleAnalyticsService } from "../../shared/services/google-analytics.service";

@Component({
  selector: "phoenix-arcgis-layer-results-dialog-component",
  templateUrl: "./arcgis-layer-results-dialog.component.html",
  styleUrls: ["./arcgis-layer-results-dialog.component.scss"],
  standalone: false,
})
export class PhoenixArcGISLayerResultsDialogComponent extends ArcGISLayerResultsDialogComponent {
  constructor(
    http: HttpClient,
    viewerConfigurationService: ViewerConfigurationService,
    geoJSONDatabaseService: GeoJSONDatabaseService,
    googleAnalyticsService: GoogleAnalyticsService,
    matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
    @Inject(VIEWER_SERVICE) public viewerService: BaseViewerService,
  ) {
    super(http, viewerConfigurationService, geoJSONDatabaseService, googleAnalyticsService, matDialog, data);
  }

  getArcGISFormatter() {
    return this.viewerService.getCoreMap().getArcGISFormatter();
  }

  saveLayer(layer: Viewerlayer) {
    this.geoJSONDatabaseService.saveLayer(layer).subscribe(() => {
      this.viewerService.addUserLayer(layer);
      this.viewerService.updateUserOrder(this.viewerService.getUserLayers());
    });
    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.ADD_DATA_ARCGISRESTFS,
      GoogleAnalyticsConstantsCategory.LEFT_TOOLBAR,
      true,
    );
  }
}
